import React from 'react';
import { Container, Col, Row, Card } from 'react-bootstrap';
import '../pages/Podcast/Podcast.css';

export const Podcasts = ({ podcasts }) => {
  return (
    <div>
      <Container className="py-4">
        <Row className="g-4">
          {podcasts && podcasts.length > 0 ? (
            podcasts.map((podcastsData, index) => {
              return (
                <Col md={12} key={podcastsData.podcasts_id || index}>
                  {podcastsData.podcasts_title !== '' ? (
                    <div className="podcast-list-card">
                      <Row className="align-items-center g-3">
                        <Col lg={4} md={5} sm={12}>
                          <h5 className="podcast-title-text text-center text-md-start">
                            {podcastsData.podcasts_title}
                          </h5>
                        </Col>
                        <Col lg={8} md={7} sm={12}>
                          <div className="podcast-audio-bar-wrap">
                            <audio controls>
                              <source src={podcastsData.podcasts_file} type="audio/mpeg" />
                            </audio>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  ) : (
                    <Card id="deptcard" className="p-4 text-center">
                      <Card.Body>
                        <Card.Title>No Podcast For Now</Card.Title>
                      </Card.Body>
                    </Card>
                  )}
                </Col>
              );
            })
          ) : (
            <Col md={12}>
              <Card id="deptcard" className="p-4 text-center">
                <Card.Body>
                  <Card.Title>No Podcast For Now</Card.Title>
                </Card.Body>
              </Card>
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
};
